<template>
    <div>
        <v-row>
            <v-col class="page-header">
            <h2>
                <span>Alterar Senha</span>
            </h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="12">
                <v-form v-model="valid" ref="form">
                    <v-row align="center" justify="space-around">
                        <v-col cols="6">
                            <v-text-field
                                disabled
                                outlined
                                label="Usuário"
                                v-model="login"
                            ></v-text-field>    
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-col cols="6">
                                <v-text-field-cpf
                                    label="Número do CPF"
                                    v-model="cpf"
                                    v-bind:properties="{
                                        readonly: false,
                                        disabled: true,
                                        outlined: true,
                                        clearable: true,
                                        placeholder: '',
                                        required: true,
                                    }"
                                    v-bind:options="{
                                        outputMask: '###########',
                                        empty: '',
                                        applyAfter: true,
                                    }"
                                />  
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                prepend-icon="lock"
                                :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                                @click:append="$store.state.showPW = !$store.state.showPW"
                                :type="$store.state.showPW ? 'text' : 'password'"
                                name="newPassword"
                                label="Nova Senha"
                                id="newpassword"
                                v-model="newPassword"
                                clearable
                                :rules="[rules.requiredRules.required]"
                                autocomplete="off"
                                />
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-col cols="6">
                            <v-text-field
                            outlined
                            prepend-icon="lock"
                            :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                            @click:append="$store.state.showPW = !$store.state.showPW"
                            :type="$store.state.showPW ? 'text' : 'password'"
                            name="passwordConfirm"
                            label="Confirmar nova senha"
                            id="passwordConfirm"
                            v-model="passwordConfirm"
                            v-on:keyup.enter="submit"
                            clearable
                            :rules="[rules.requiredRules.required, rules.requiredRules.matchPassword]"
                            autocomplete="off"
                            />
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-col cols="6">
                            <v-btn
                                @click="submit"
                                elevation="0"
                                color="primary"
                                large
                                rounded
                                ><v-icon left>mdi-check</v-icon>
                                ALTERAR</v-btn>
                                
                            <v-btn
                                elevation="0"
                                color="primary"
                                large
                                outlined
                                rounded 
                                @click="$router.push({ path: '/'})">
                                <v-icon left>mdi-cancel</v-icon>CANCELAR
                            </v-btn>
                            
                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
            <snackbar :text="snackbarMessage" :color="snackbarColor" />
        </v-row>
        <v-dialog v-model="dialog" width="400">
            <v-card outlined elevation="4">
                <v-card-title>Aviso</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text--primary espaco-top" v-html="messageResult">
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary"
                    large
                    outlined
                    elevation="0"
                    rounded class="text-right" @click="close">CONFIRMAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import snackbarMixin from "../../mixins/snackbar.mixin";
import Cpf from '../../components/masked/cpf.vue';
import userService from '../../services/users.service';

export default {
    mixins: [snackbarMixin],
    components: {
        "v-text-field-cpf": Cpf,
    },      
    data(){
        return {
            valid: false,
            chave: '',
            login: '',
            cpf: '',
            newPassword:'',
            passwordConfirm: '',
            dialog:false,
            messageResult: '',
            rules: {
                requiredRules: {
                required: value => !!value || 'Campo obrigatório',
                matchPassword: value =>
                    value === this.newPassword || 'Senha está diferente'
                }
            }
        };
    },
    mounted(){
        if (this.$refs.password) {
            this.$refs.password.focus();
        }

        this.resolveQuery(this.$route.query);
    },
    methods:{
        close(){
            this.$router.push({ name : 'login' });
        },
        submit(){
            if (this.$refs.form.validate()) {
                this.$store.state.loading = true;
                var data = {
                    Chave: this.chave,
                    Login: this.login,
                    CPF: this.cpf,
                    Senha: this.newPassword,
                    SenhaConfirmacao: this.passwordConfirm
                };
                
                userService.updatePasswordByMail(data)
                .then((res) => {
                    console.log(res);
                    if(res != null && res.Status == "OK"){
                        this.dialog = true;
                        this.messageResult = 'Senha alterada com sucesso.<br/>Favor efetuar o login para acessar o sistema.';
                    } else {
                        this.showSnackbar(res.Mensagem, 'error');
                    }
                    this.$store.state.loading = false;
                }).catch(error=>{
                    this.$store.state.loading = false;
                    this.showSnackbar(error, 'error');
                });
               }
        },
        resolveQuery(params){
            console.log(params);
            if(params == null || params == "" || params.q1 == null || params.q1 == undefined){
                this.dialog = true;
                this.messageResult = 'Parâmetros inválidos. Não é possível continuar o processamento.';
            } else {
                let arrParams = params.q1.split('|');

                if(arrParams == null || arrParams.length != 3 || arrParams[1] == '' || arrParams[2] == null || !this.isNumeric(arrParams[2]))
                {
                    this.dialog = true;
                    this.messageResult = 'Parâmetros inválidos. Não é possível continuar o processamento.';
                } else {
                    this.validateKey(arrParams[0], arrParams[2], arrParams[1])
                }
            }
        },
        isNumeric(str){
            if(typeof str != "string") return false;
            return !isNaN(str) && !isNaN(parseFloat(str));
        },
        validateKey(key, cpf, login){
            var data = {
                Chave: key,
                Cpf: cpf,
                Login: login,
            }
            userService.validarChave(data)
            .then((res) => {
                    if(res != null && res.Status != null){
                        if(res.Status != "OK"){
                            this.messageResult = res.Mensagem;
                            this.dialog = true;
                        } else {
                            this.login = login;
                            this.cpf = cpf;
                            this.chave = key;
                        } 
                    }
                })
            .catch((err) => {
                console.log(err);
                this.showSnackbar('Não foi possivel finalizar a alteração solicitada.', 'error');
            });
        }
    }
}
</script>
<style scoped>

</style>